import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonToggle from '@redbubble/design-system/react/ButtonToggle';
import { FormattedMessage } from 'react-intl';
import * as constants from '@redbubble/design-system/react/constants';
import {
  analyticsPayload,
  FOLLOW_ACTION,
  UNFOLLOW_ACTION
} from '../../lib/analytics';
import messages from './messages';

// eslint-disable-next-line react/prefer-stateless-function
class FollowButton extends Component {
  render() {
    const {
      isLoggedIn,
      openSignUpModal,
      signUpModalImage,
      followed,
      followArtist,
      unfollowArtist,
      artistId,
      analyticsLabel,
      analyticsValue,
      logEvent
    } = this.props;

    const handleNonMemberFollow = () => openSignUpModal(signUpModalImage);

    const toggleFollow = () => {
      if (followed) {
        unfollowArtist({ artistId });
        logEvent({
          analytics: analyticsPayload.follow(
            UNFOLLOW_ACTION,
            analyticsLabel,
            analyticsValue
          )
        });
      } else {
        followArtist({ artistId });
        logEvent({
          analytics: analyticsPayload.follow(
            FOLLOW_ACTION,
            analyticsLabel,
            analyticsValue
          )
        });
      }
    };

    const handleFollowClick = isLoggedIn ? toggleFollow : handleNonMemberFollow;

    const handleClick = e => {
      e.preventDefault();
      e.stopPropagation();
      handleFollowClick();
    };

    return (
      <ButtonToggle
        size={constants.SMALL}
        onClick={handleClick}
        active={followed}
      >
        {followed ? (
          <FormattedMessage {...messages.Following} />
        ) : (
          <FormattedMessage {...messages.Follow} />
        )}
      </ButtonToggle>
    );
  }
}

FollowButton.propTypes = {
  isLoggedIn: PropTypes.bool,
  openSignUpModal: PropTypes.func,
  signUpModalImage: PropTypes.string,
  artistId: PropTypes.number.isRequired,
  followed: PropTypes.bool,
  followArtist: PropTypes.func,
  unfollowArtist: PropTypes.func,
  analyticsLabel: PropTypes.string,
  analyticsValue: PropTypes.number,
  logEvent: PropTypes.func
};

FollowButton.defaultProps = {
  isLoggedIn: false,
  openSignUpModal: () => {},
  followed: false,
  followArtist: () => {},
  unfollowArtist: () => {},
  logEvent: () => {}
};

FollowButton.displayName = 'FollowButton';

export default FollowButton;
